var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrowSlider = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.657 6 3 11.657l5.657 5.657",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 4.157,
  y: 11.157,
  width: 17,
  height: 1,
  rx: 0.5,
  fill: "currentColor",
  stroke: "currentColor"
})));
export default SvgArrowSlider;